<template>
  <el-form>
    <el-form-item v-if="eventType">
      <span v-if="eventType === 'click'" slot="label" class="sw-2-title"
        >点击时</span
      >
      <span v-if="eventType === 'change'" slot="label" class="sw-2-title"
        >值改变时</span
      >
      <span v-if="eventType === 'blur'" slot="label" class="sw-2-title"
        >失去焦点时
      </span>
      ：
      <el-tooltip
        class="item"
        effect="dark"
        content="切换后，只有选中项函数有效"
        placement="bottom-start"
        style="margin-right: 10px"
      >
        <span style="color: #ff9343"><i class="el-icon-warning"></i></span>
      </el-tooltip>
      <el-select v-model="dialogEvent.functions" clearable placeholder="请选择">
        <el-option
          v-for="item in functionSelItems"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <!-- 条件 -->
    <el-form-item v-if="eventType && dialogEvent.functions">
      <span slot="label" class="sw-2-title">设置触发条件：</span>
      <el-tooltip
        class="item"
        effect="dark"
        content="条件为空时，默认直接执行"
        placement="bottom-start"
      >
        <span style="color: #ff9343"
          ><i class="el-icon-warning"></i
        ></span> </el-tooltip
      ><br />
      <div class="sw-event-function" v-if="eventType && dialogEvent.functions">
        <draggable
          tag="ul"
          :list="dialogEvent.eventList"
          v-bind="{
            group: { name: 'options' },
            ghostClass: 'ghost',
            handle: '.drag-item',
          }"
          handle=".drag-item"
        >
          <li v-for="(item, index) in dialogEvent.eventList" :key="index">
            <i class="drag-item"><i class="iconfont icon-icon_bars"></i></i>
            <el-button
              @click="remove(index)"
              circle
              plain
              type="danger"
              size="mini"
              icon="el-icon-minus"
              class="sw-remove"
            ></el-button>
            条件：<br />
            <span v-for="(cond, index1) in item.condition" :key="index1">
              <span>
                <el-select
                  v-model="cond.field"
                  placeholder="请选择"
                  filterable
                  clearable
                  style="width: 120px"
                >
                  <el-option
                    v-for="coo in dataList"
                    v-if="
                      ((!isSon && !coo.isSon) || (isSon && coo.isSon)) &&
                      coo.type !== 'page' &&
                      coo.type !== 'sonform' &&
                      coo.type !== 'divider' &&
                      coo.type !== 'swtext'
                    "
                    :key="coo.key"
                    :label="coo.name"
                    :value="coo.model"
                  >
                    <span style="float: left">{{ coo.name }}</span>
                    <i
                      v-if="coo.icon.indexOf('sw-icon') == 0"
                      class="icon"
                      :class="coo.icon"
                      style="float: right; color: #8492a6; font-size: 13px"
                    ></i>
                    <i
                      v-else
                      class="icon iconfont"
                      :class="coo.icon"
                      style="float: right; color: #8492a6; font-size: 13px"
                    ></i>
                  </el-option>
                </el-select>
              </span>
              <span v-if="cond.field">
                <el-select
                  v-model="cond.expression"
                  placeholder="请选择"
                  clearable
                  style="width: 100px"
                >
                  <el-option label="等于" value="="></el-option>
                  <el-option label="不等于" value="!="></el-option>
                  <el-option label="大于" value=">"></el-option>
                  <el-option label="大于等于" value=">="></el-option>
                  <el-option label="小于" value="<"></el-option>
                  <el-option label="小于等于" value="<="></el-option>
                  <el-option label="包含" value="include"></el-option>
                  <el-option label="不包含" value="unInclude"></el-option>
                  <el-option label="为空" value="isnull"></el-option>
                  <el-option label="不为空" value="notnull"></el-option>
                </el-select>
              </span>
              <span
                v-if="
                  cond.field &&
                  cond.expression &&
                  cond.expression !== 'isnull' &&
                  cond.expression !== 'notnull'
                "
              >
                <el-input
                  v-model="cond.value"
                  placeholder="请输入值"
                  style="width: 100px"
                ></el-input>
              </span>
              <span v-if="index1 + 1 < item.condition.length">
                <el-select
                  v-model="cond.relation"
                  placeholder="条件关系"
                  clearable
                  style="width: 100px"
                >
                  <el-option label="和" value="&&"></el-option>
                  <el-option label="或" value="||"></el-option>
                </el-select>
              </span>
              <el-button
                type="primary"
                icon="el-icon-plus"
                class="sw-but-padding"
                size="mini"
                circle
                @click="addRow(item)"
              ></el-button>
              <el-button
                v-if="item.condition.length > 1"
                type="warning"
                icon="el-icon-close"
                class="sw-but-padding"
                size="mini"
                circle
                @click="delRow(item, index1)"
              ></el-button>
              <br />
            </span>
            <span>
              设置函数
              <el-button
                v-if="!item.show"
                type="text"
                class="sw-func-bt"
                @click="item.show = true"
                >展开<i class="el-icon-caret-bottom"></i
              ></el-button>
              <el-button
                v-if="item.show"
                type="text"
                class="sw-func-bt"
                @click="item.show = false"
                >收起<i class="el-icon-caret-top"></i
              ></el-button>
            </span>
            <!-- <span v-if="item.func && item.func.name">
                            {{item.func.name}}
                        </span>-->
            <!-- 具体事件事物 -->
            <div v-if="item.show" class="sw-func-detail">
              <!--函数名称：<el-input v-model="item.func.name" placeholder="请输入函数名称" style="width: 40%"></el-input>-->
              <!-- 表单级联 -->
              <div v-if="dialogEvent.functions === 'cascadeDom'">
                <!--<span class="sw-col-text">组件级联</span>-->
                是否设置接口：
                <el-select
                  v-model="item.isSetUrl"
                  @change="isUseUrl(item)"
                  placeholder="请选择"
                  style="width: 100px"
                >
                  <el-option label="设置" :value="true"></el-option>
                  <el-option
                    label="不设置"
                    :value="false"
                  ></el-option> </el-select
                >&nbsp;&nbsp;
                <template v-if="item.isSetUrl">
                  设置级联接口：
                  <api-select
                    :id="designId"
                    :sel-value.sync="item.func.url"
                    :result.sync="item.cascadeFields"
                    :config-options.sync="configOptions"
                    width="100"
                  ></api-select>
                  <div style="margin-top: 10px"></div>
                  <el-input size="mini" v-model="item.func.paramFormat">
                    <template slot="prepend">参数格式</template>
                  </el-input>
                </template>
                <!--<el-input v-model="item.func.url" placeholder="请输入级联接口" style="width: 60%"></el-input>-->
                <div
                  v-for="(cas, casIndex) in item.cascadeList"
                  :key="casIndex"
                  style="margin-top: 10px"
                >
                  <span
                    >组件：
                    <el-select
                      v-model="cas.field"
                      placeholder="请选择组件"
                      filterable
                      clearable
                      style="width: 160px"
                    >
                      <el-option
                        v-for="coo in dataList"
                        v-if="
                          (!isSon || (isSon && coo.isSon)) &&
                          coo.type !== 'page' &&
                          coo.type !== 'sonform' &&
                          coo.type !== 'divider' &&
                          coo.type !== 'swtext'
                        "
                        :key="coo.key"
                        :label="coo.name"
                        :value="coo.model"
                      >
                        <span style="float: left">{{ coo.name }}</span>
                        <i
                          v-if="coo.icon.indexOf('sw-icon') == 0"
                          class="icon"
                          :class="coo.icon"
                          style="float: right; color: #8492a6; font-size: 13px"
                        ></i>
                        <i
                          v-else
                          class="icon iconfont"
                          :class="coo.icon"
                          style="float: right; color: #8492a6; font-size: 13px"
                        ></i>
                      </el-option>
                    </el-select>
                  </span>
                  <span v-if="cas.field && item.isSetUrl">
                    数据库字段：
                    <el-select
                      v-model="cas.dbField"
                      placeholder="请选择数据库字段"
                      filterable
                      clearable
                      style="width: 160px"
                    >
                      <el-option
                        v-for="coo in item.cascadeFields"
                        :key="coo"
                        :label="coo"
                        :value="coo"
                      ></el-option>
                    </el-select>
                  </span>
                  <span v-if="cas.field && !item.isSetUrl">
                    值：
                    <el-input
                      v-model="cas.value"
                      type="textarea"
                      :rows="1"
                      placeholder="请设置值"
                      clearable
                      style="width: 160px"
                    ></el-input>
                  </span>
                  <el-button
                    @click="removeCas(item, casIndex)"
                    circle
                    plain
                    type="danger"
                    size="mini"
                    icon="el-icon-minus"
                    class="sw-remove"
                  ></el-button>
                </div>
                <div>
                  <el-button type="text" @click="addCas(item)"
                    >添加绑定关系</el-button
                  >
                </div>
              </div>
              <!-- 表单隐藏 / 显示 -->
              <div v-if="dialogEvent.functions === 'hiddenDom'">
                <el-row class="sw-row">
                  <el-col class="sw-col-text sw-com-hide" :span="10">
                    要隐藏组件<el-button
                      type="text"
                      @click="item.func.hide = []"
                      style="margin-left: 20px"
                      >清空</el-button
                    >
                  </el-col>
                  <el-col
                    class="sw-col-text sw-com-show"
                    :span="10"
                    :offset="1"
                  >
                    要显示组件<el-button
                      type="text"
                      @click="item.func.show = []"
                      style="margin-left: 20px"
                      >清空</el-button
                    >
                  </el-col>
                </el-row>
                <el-row class="sw-row">
                  <el-col class="sw-col sw-com-hide" :span="10">
                    <el-select
                      class="sw-com-select"
                      v-model="item.func.hide"
                      multiple
                      filterable
                      placeholder="请选择要隐藏组件"
                    >
                      <el-option
                        v-for="coo in dataList"
                        v-if="
                          (!isSon || (isSon && coo.isSon)) &&
                          coo.type !== 'hidden'
                        "
                        :key="coo.key"
                        :label="coo.name"
                        :value="coo.model"
                      >
                        <span>{{ coo.name }}</span>
                        <i
                          v-if="coo.icon.indexOf('sw-icon') == 0"
                          class="icon"
                          :class="coo.icon"
                          style="padding-left: 10px"
                        ></i>
                        <i
                          v-else
                          class="icon iconfont"
                          :class="coo.icon"
                          style="padding-left: 10px"
                        ></i>
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="sw-col sw-com-show" :span="10" :offset="1">
                    <el-select
                      class="sw-com-select"
                      v-model="item.func.show"
                      multiple
                      filterable
                      placeholder="请选择要显示组件"
                    >
                      <el-option
                        v-for="coo in dataList"
                        v-if="
                          (!isSon || (isSon && coo.isSon)) &&
                          coo.type !== 'hidden'
                        "
                        :key="coo.key"
                        :label="coo.name"
                        :value="coo.model"
                      >
                        <span>{{ coo.name }}</span>
                        <i
                          v-if="coo.icon.indexOf('sw-icon') == 0"
                          class="icon"
                          :class="coo.icon"
                          style="padding-left: 10px"
                        ></i>
                        <i
                          v-else
                          class="icon iconfont"
                          :class="coo.icon"
                          style="padding-left: 10px"
                        ></i>
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
              <!-- 表单禁用 / 正常 -->
              <div v-if="dialogEvent.functions === 'disabledDom'">
                <el-row class="sw-row">
                  <el-col class="sw-col-text sw-com-hide" :span="10">
                    要禁用组件<el-button
                      type="text"
                      @click="item.func.disabled = []"
                      style="margin-left: 20px"
                      >清空</el-button
                    >
                  </el-col>
                  <el-col
                    class="sw-col-text sw-com-show"
                    :span="10"
                    :offset="1"
                  >
                    要正常显示组件<el-button
                      type="text"
                      @click="item.func.undisabled = []"
                      style="margin-left: 20px"
                      >清空</el-button
                    >
                  </el-col>
                </el-row>
                <el-row class="sw-row">
                  <el-col class="sw-col sw-com-hide" :span="10">
                    <el-select
                      class="sw-com-select"
                      v-model="item.func.disabled"
                      multiple
                      filterable
                      placeholder="请选择要禁用组件"
                    >
                      <el-option
                        v-for="coo in dataList"
                        v-if="
                          (!isSon || (isSon && coo.isSon)) &&
                          coo.type !== 'sonform' &&
                          coo.type !== 'hidden'
                        "
                        :key="coo.key"
                        :label="coo.name"
                        :value="coo.model"
                      >
                        <span>{{ coo.name }}</span>
                        <i
                          v-if="coo.icon.indexOf('sw-icon') == 0"
                          class="icon"
                          :class="coo.icon"
                          style="padding-left: 10px"
                        ></i>
                        <i
                          v-else
                          class="icon iconfont"
                          :class="coo.icon"
                          style="padding-left: 10px"
                        ></i>
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="sw-col sw-com-show" :span="10" :offset="1">
                    <el-select
                      class="sw-com-select"
                      v-model="item.func.undisabled"
                      multiple
                      filterable
                      placeholder="请选择要正常显示组件"
                    >
                      <el-option
                        v-for="coo in dataList"
                        v-if="
                          (!isSon || (isSon && coo.isSon)) &&
                          coo.type !== 'sonform' &&
                          coo.type !== 'hidden'
                        "
                        :key="coo.key"
                        :label="coo.name"
                        :value="coo.model"
                      >
                        <span>{{ coo.name }}</span>
                        <i
                          v-if="coo.icon.indexOf('sw-icon') == 0"
                          class="icon"
                          :class="coo.icon"
                          style="padding-left: 10px"
                        ></i>
                        <i
                          v-else
                          class="icon iconfont"
                          :class="coo.icon"
                          style="padding-left: 10px"
                        ></i>
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
              <!-- 表单弹窗 -->
              <div v-if="dialogEvent.functions === 'alertPage'">
                <span class="sw-col-text">弹窗内容</span>
                <fm-editor v-model="item.func.alert"></fm-editor>
              </div>
            </div>
          </li>
        </draggable>
        <div style="margin-left: 22px; margin-top: 14px">
          <el-button type="text" @click="addEvent">添 加 函 数</el-button>
        </div>
      </div>
    </el-form-item>

    <!-- -->
  </el-form>
</template>

<script>
import Draggable from 'vuedraggable'
import FmEditor from '../Editor/index'
import ApiSelect from '../advanced/custom/index'
export default {
  name: 'event',
  components: {
    Draggable,
    FmEditor,
    ApiSelect,
  },
  props: ['designId', 'dialogEvent', 'dataList', 'eventType', 'isSon'],
  data() {
    return {
      functionSelItems: [
        { name: '隐藏/显示', value: 'hiddenDom' }, // 隐藏其他组件
        { name: '级联', value: 'cascadeDom' }, // 级联其他组件
        { name: '弹窗', value: 'alertPage' }, // 弹出页面信息
        { name: '禁用/正常', value: 'disabledDom' }, // 禁用 组件
      ],
      configOptions: [],
    }
  },
  created() {},
  methods: {
    addCas(obj) {
      obj.cascadeList.push({
        field: '',
        dbField: '',
      })
    },
    removeCas(obj, index) {
      obj.cascadeList.splice(index, 1)
    },
    remove(index) {
      this.$confirm('确认删除该条件？')
        .then(() => {
          this.dialogEvent.eventList.splice(index, 1)
        })
        .catch(() => {})
    },
    addEvent() {
      this.dialogEvent.eventList.push({
        condition: [
          {
            field: '', // 字段
            expression: '', // 表达式
            value: '', // 值
            relation: '', // 关系
          },
        ], // 条件
        show: false,
        cascadeList: [],
        cascadeFields: [],
        isSetUrl: false,
        func: {},
      })
    },
    isUseUrl(item) {
      // 判断是否通过接口级联，切换后会将之前数据清空
      if (
        (item.func && (item.func.url || item.func.paramFormat)) ||
        (item.cascadeList && item.cascadeList.length > 0)
      ) {
        this.$confirm('切换后绑定数据将清空，确认切换？').then(() => {
          if (!item.isSetUrl) {
            item.cascadeFields = []
            item.func = {}
          }
          item.cascadeList = []
        })
      }
    },
    addRow(item) {
      item.condition.push({
        field: '',
        expression: '',
        value: '',
        relation: '',
      })
    },
    delRow(item, index) {
      if (item.condition.length === 1) {
        return
      }
      this.$confirm('确认删除该条件？')
        .then(() => {
          item.condition.splice(index, 1)
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
.sw-2-title {
  font-weight: bold;
  font-size: 13px;
}
.sw-event-function {
  margin-left: 20px;
}
.sw-event-function li {
  list-style: none;
  margin-top: 10px;
  width: 100%;
}
.sw-event-function li span {
  margin-right: 5px;
}
.sw-event-function .drag-item {
  font-size: 16px;
  margin-right: 20px;
}
.sw-event-function .sw-remove {
  padding: 4px;
  margin-left: -5px;
  margin-right: 5px;
}
.sw-func-bt {
  margin-left: 5px;
}
.sw-func-detail {
  margin-top: 10px;
  margin-left: 35px;
}
.sw-row {
  margin-top: 5px;
}
.sw-col-text {
  font-weight: bold;
}
.el-select__tags-text {
  width: 150px;
}
.el-select .el-tag__close.el-icon-close {
  right: -77px;
}
</style>
